import React from "react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import MilitaryVerifyCard from "@/components/public/MilitaryVerifyCard";
import { Button } from "@/components/ui/button";
import { VETERAN } from "@/constants/testIds";
import { Loader2, ShieldCheck, Lock } from "lucide-react";

// Gates children behind a VERIFIED VETERAN status (customer.is_verified_veteran).
// Not eligible -> shows a branded gate with the ID.me verification CTA instead of
// hard-redirecting, so the visitor understands how to gain access.
export default function VeteranProtectedRoute({ children }) {
  const { customer, loading, openAuthModal } = useCustomerAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <Loader2 size={32} className="text-[#c9a86a] animate-spin" />
      </div>
    );
  }

  if (customer?.is_verified_veteran) {
    return children;
  }

  return (
    <PublicLayout>
      <section className="max-w-lg mx-auto px-5 py-24 text-center" data-testid={VETERAN.gate}>
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-[#c9a86a] mb-6">
          <Lock size={22} className="text-[#c9a86a]" />
        </div>
        <div className="text-[#c9a86a] tracking-[0.3em] text-xs mb-2">VETERANS&rsquo; CIRCLE</div>
        <h1 className="text-2xl md:text-3xl font-semibold text-[var(--text)] mb-3">A private space for those who served</h1>
        <p className="text-[var(--text-2)] mb-8">
          {customer
            ? "This area is reserved for verified veterans. Verify your service through ID.me to unlock access and your standing 10% benefit."
            : "This area is reserved for verified veterans. Sign in, then verify your service through ID.me to unlock access."}
        </p>

        <div className="max-w-sm mx-auto text-left">
          {!customer && (
            <Button onClick={openAuthModal} data-testid="veteran-gate-signin"
              className="w-full mb-4 bg-[var(--panel-2)] border border-[var(--border-2)] text-[var(--text)] hover:bg-[var(--panel)] rounded-none">
              <ShieldCheck size={16} className="mr-2 text-[#c9a86a]" /> Sign in to continue
            </Button>
          )}
          <MilitaryVerifyCard />
        </div>
      </section>
    </PublicLayout>
  );
}
